// extracted by mini-css-extract-plugin
export default {"container":"tY-z","title":"uY-z","link":"vY-z"};